import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../axios";

export const postProfileImage = async (newImageFormData) => {
  await axiosInstance.post(
    `/umbraco/api/MyAccountApi/SubmitProfileImage/`,
    newImageFormData,
    {
      headers: {
        'Content-Type': 'multipart/form-data', 
      },
    }
  );
};

export const useProfileImage = () => {
  return useQuery({
    queryKey: ["profile-image-widget"],
    queryFn: null,
    enabled: false,
  });
};
